import LocalStorageService from 'web-app/services/local-storage';
import {
    type FamlyticsEvent,
    type EncryptedEvent,
    EVENTS_KEY,
    HEARTBEAT_KEY,
    KEYPART_KEY,
} from '@famly/stat_ts-utils_famlytics';
import {decrypt, encrypt, getEncryptionKey} from '@famly/stat_ts-utils_cryptography';
import {getKeyPart} from '@famly/stat_ts-utils_local-storage';

const getAll = () => {
    return (LocalStorageService.getFromLocalStorage(EVENTS_KEY) as {[x: string]: EncryptedEvent[]}) || {};
};

const get = (loginId: string) => {
    return getAll()[loginId] || [];
};

const save = (events: EncryptedEvent[], loginId: string) => {
    const allEvents = getAll();
    allEvents[loginId] = events;
    LocalStorageService.saveToLocalStorage(EVENTS_KEY, allEvents);
};

export const saveEvent = (event: FamlyticsEvent, secret: string, loginId: string) => {
    const events = get(loginId);
    events.push({
        event: encrypt(event, getEncryptionKey(secret, getKeyPart(loginId))),
        id: event.eventId,
    });
    save(events, loginId);
};

export const peek = (chunk: number, secret: string, loginId: string) => {
    const events = get(loginId);
    const eventsChunk = events.slice(0, chunk);
    return eventsChunk.map(event => {
        return {
            id: event.id,
            event: decrypt(event.event, getEncryptionKey(secret, getKeyPart(loginId))),
        };
    });
};

export const remove = (eventIdsToRemove: string[], loginId: string) => {
    if (eventIdsToRemove.length === 0) {
        return;
    }

    const eventsLeft = get(loginId).filter(event => !eventIdsToRemove.includes(event.id));
    save(eventsLeft, loginId);
};

export const removeAll = () => {
    LocalStorageService.clearKey(EVENTS_KEY);
};

export const flush = () => {
    LocalStorageService.clearKey(EVENTS_KEY);
    LocalStorageService.clearKey(KEYPART_KEY);
    LocalStorageService.clearKey(HEARTBEAT_KEY);
};
